export enum McpQueryKeys {
  /** Settings → MCP connections (LAB-2995). The old Email & Accounts card uses its own `mcp-authorizations` key. */
  CONNECTIONS = 'mcp-connections',
  ACCESS_REQUEST = 'mcp-access-request',
}
